import React from 'react';
import { Link } from 'react-router-dom';
// Optional: Import icons for social media if needed
// import { FaGithub, FaTwitter, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Simplified sitemap for Figma-inspired dark footer
  const footerSections = {
    'Solutions': [
      { to: '/solutions/ai-development', text: 'AI & Machine Learning' },
      { to: '/solutions/robotics', text: 'Robotics & Automation' },
      { to: '/services/software-development', text: 'Software Engineering' },
      { to: '/services/cloud-solutions', text: 'Cloud Solutions' },
    ],
    'Company': [
      { to: '/about', text: 'About Us' },
      { to: '/careers', text: 'Careers' },
      { to: '/press', text: 'Press Room' },
      { to: '/contact', text: 'Contact Us' },
    ],
    'Resources': [
      { to: '/faq', text: 'FAQ' }, // Placeholder
      { to: '/support', text: 'Support Center' }, // Placeholder
      { to: '/blog', text: 'Blog' }, // Example
    ],
    'Legal': [
      { to: '/privacy', text: 'Privacy Policy' },
      { to: '/terms', text: 'Terms of Service' },
      { to: '/cookie-policy', text: 'Cookie Policy' },
    ],
  };

  return (
    <footer className="bg-figma-dark-bg-secondary text-figma-dark-text-secondary border-t border-figma-dark-border/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-10">
          {/* Logo & Copyright - Spans 2 cols on larger screens for balance */}
          <div className="col-span-2 lg:col-span-1 mb-6 md:mb-0 pr-4">
            <Link to="/" className="inline-block mb-4">
              <img className="h-8 w-auto" src="/assets/logo.png" alt="Interdize Technologies Logo" />
            </Link>
            <p className="text-xs text-figma-dark-text-secondary/80">
              &copy; {currentYear} Interdize Technologies. <br />Empowering Innovation.
            </p>
            {/* Optional: Social Media Icons - Keep it clean for Figma style */}
            {/* <div className="mt-4 flex space-x-4">
              <a href="#" target="_blank" rel="noopener noreferrer" className="text-figma-dark-text-secondary hover:text-figma-dark-primary"><FaGithub size={18}/></a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="text-figma-dark-text-secondary hover:text-figma-dark-primary"><FaTwitter size={18}/></a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="text-figma-dark-text-secondary hover:text-figma-dark-primary"><FaLinkedin size={18}/></a>
            </div> */}
          </div>
          
          {Object.entries(footerSections).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-sm font-semibold text-figma-dark-text-primary mb-4 tracking-wide uppercase">{title}</h3>
              <ul className="space-y-3 text-sm">
                {links.map(link => (
                  <li key={link.text}>
                    <Link to={link.to} className="text-figma-dark-text-secondary hover:text-figma-dark-primary hover:underline transition-colors duration-200">
                      {link.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-figma-dark-border/30 text-center">
          <p className="text-xs text-figma-dark-text-secondary/70">
            Interdize Technologies. - City Center, Gwalior City, MP 474005, India
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 